var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulbCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 51,
    rx: 25,
    fill: "#F2FFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.541 35.4131H20.9785C20.8582 35.4131 20.7598 35.5115 20.7598 35.6318V36.5068C20.7598 36.9908 21.1508 37.3818 21.6348 37.3818H26.8848C27.3688 37.3818 27.7598 36.9908 27.7598 36.5068V35.6318C27.7598 35.5115 27.6613 35.4131 27.541 35.4131ZM24.2598 12.8818C19.3078 12.8818 15.291 16.8986 15.291 21.8506C15.291 25.1701 17.0957 28.0686 19.7754 29.6189V32.7881C19.7754 33.2721 20.1664 33.6631 20.6504 33.6631H27.8691C28.3531 33.6631 28.7441 33.2721 28.7441 32.7881V29.6189C31.4238 28.0686 33.2285 25.1701 33.2285 21.8506C33.2285 16.8986 29.2117 12.8818 24.2598 12.8818ZM27.757 27.9154L26.7754 28.4842V31.6943H21.7441V28.4842L20.7625 27.9154C18.6105 26.6713 17.2598 24.3799 17.2598 21.8506C17.2598 17.9842 20.3934 14.8506 24.2598 14.8506C28.1262 14.8506 31.2598 17.9842 31.2598 21.8506C31.2598 24.3799 29.909 26.6713 27.757 27.9154Z",
    fill: "#59B3A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbCircle);
export default __webpack_public_path__ + "static/media/bulb-circle.0fd23a4a.svg";
export { ForwardRef as ReactComponent };